import React, {useEffect, useState} from 'react';
import {useDropzone} from 'react-dropzone';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import "./singleselectdropzone.scss"

type choosedFile = {
    preview: string
}

interface IDropZone {
    title: string
}

export default function SingleSelectDropzone({title}: IDropZone) {
    const [files, setFiles] = useState<choosedFile[]>([]);
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        accept: {
            'image/*': []
        },
        onDrop: acceptedFiles => {
            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));
        }
    });

    const thumbs = files.map((file, index) => (
        <div className="Single-Select-Drop-Zone-Preview" key={index}>
            <img
                className="img-fluid img-thumbnail"
                src={file.preview}
                alt={"selected"}
                onLoad={() => {
                    URL.revokeObjectURL(file.preview)
                }}
            />
        </div>
    ));

    useEffect(() => {
        return () => files.forEach(file => URL.revokeObjectURL(file.preview));
    }, []);

    return (
        <div className="Single-Select-Drop-Zone">
            <div className="Single-Select-Drop-Zone-Top">
                <span>{title}</span>
                <div {...getRootProps({className: 'dropzone Single-Select-Drop-Zone-Box'})}>
                    <input {...getInputProps()} multiple={false}/>
                    {
                        isDragActive ? <p>عکس را رها کنید</p> : <ControlPointIcon fontSize={"large"}/>
                    }
                </div>
            </div>
            {thumbs}
        </div>
    );
}